import * as React from "react";

function SvgPlate(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 34 27" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34 0v26.917H0V4.25L4.25 0H34zM4.25 4.25H8.5V8.5H4.25V4.25zm7.083 0h4.25V8.5h-4.25V4.25zm11.334 0h-4.25V8.5h4.25V4.25zm2.833 0h4.25V8.5H25.5V4.25zM4.25 11.333H8.5v4.25H4.25v-4.25zm7.083 0h4.25v4.25h-4.25v-4.25zm11.334 0h-4.25v4.25h4.25v-4.25zm2.833 0h4.25v4.25H25.5v-4.25zm-17 7.084H4.25v4.25H8.5v-4.25zm7.083 0h-4.25v4.25h4.25v-4.25zm2.834 0h4.25v4.25h-4.25v-4.25zm11.333 0H25.5v4.25h4.25v-4.25z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgPlate;
